"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showContextMenu = void 0;
var core_1 = require("@blueprintjs/core");
var react_1 = __importDefault(require("react"));
function MessageMenu(props) {
    var _this = this;
    return (react_1.default.createElement(core_1.Menu, null, props.customActions.map(function (action) {
        return (react_1.default.createElement(core_1.MenuItem, { key: action.id, text: action.label, onClick: action.onClick.bind(_this, action.id, props.element) }));
    })));
}
var showContextMenu = function (e, props) {
    var customActions = props.store.view.customActions;
    if (props.store.config.isEmulator) {
        customActions.push({
            id: 'actionDebug',
            label: 'Inspect in Debugger',
            onClick: function (_actionId, props) {
                props.store.loadEventInDebugger(props.incomingEventId, true);
            }
        });
    }
    if (customActions && props.incomingEventId) {
        e.preventDefault();
        var menu = react_1.default.createElement(MessageMenu, { element: props, customActions: customActions });
        core_1.ContextMenu.show(menu, { left: e.clientX, top: e.clientY });
    }
};
exports.showContextMenu = showContextMenu;
